<template>
	<section class="con-1334 box-white mt-30px">
		<div class="form">
			<div class="row con-1060 mb-30px">
				<div v-for="(input, key) in elements" :key="key" :class="input.groupClass" v-if="isVisible(input)">
					<div class="grid-position" :class="input.gridClass">
						<CalcElem
							v-for="(input, key) in input.elements"
							:key="key"
							:name="key"
							:options="input"
							:ref="key"
							:class="[input.inputClass, wrapClass(input)]"
						/>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {
			counter: 0,
			inputs: [
				{
					id: 'fields0',
				},
			],
		};
	},
	props: {
		elements: { type: Object, default: () => {} },
	},
	computed: {
		wrapClass() {
			return input => {
				return input.wrapClass !== undefined ? `${input.wrapClass}` : null;
			};
		},
		isVisible() {
			return input => {
				if (_.has(input, 'visibleIf')) {
					return this.$store.getters[input.visibleIf];
				}

				return true;
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.grid-position {
	display: flex;
	flex-wrap: wrap;
}
.valuables-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-template-areas: 'a a a a' 'l l l l' 'b b b b' 'c d e f' 'g h i j' 'k k k k';

	@media screen and (max-width: 575px) {
		grid-template-areas:
			'a a a a'
            'l l l l'
			'b b b b'
			'c c c c'
			'g g g g'
			'd d d d'
			'h h h h'
			'e e e e'
			'i i i i'
			'f f f f'
			'j j j j'
			'k k k k';
	}

	.grid-a {
		grid-area: a;
	}

	.grid-b {
		grid-area: b;
	}

	.grid-c {
		grid-area: c;
		margin: 0 10px;
	}

	.grid-d {
		grid-area: d;
	}

	.grid-e {
		grid-area: e;
		margin: 0 10px;
	}

	.grid-f {
		grid-area: f;
		margin: 0 10px;
	}

	.grid-g {
		grid-area: g;
		margin: 0 10px;
	}

	.grid-h {
		grid-area: h;
		margin: 0 10px;
	}

	.grid-i {
		grid-area: i;
		margin: 0 10px;
	}

	.grid-j {
		grid-area: j;
		margin: 0 10px;
	}

	.grid-k {
		grid-area: k;
	}
    .grid-l {
        grid-area: l;
    }
}
</style>
